import { ActAdvertisingServiceType, ActProductType } from 'store/models/acts';

export const ACT_ADVERTISING_SERVICE_TYPES = {
    [ActAdvertisingServiceType.Advertising]: 'admin.actsReport.advertisingServiceType.advertising',
    [ActAdvertisingServiceType.Information]: 'admin.actsReport.advertisingServiceType.information',
    [ActAdvertisingServiceType.NotMarked]: 'admin.actsReport.advertisingServiceType.notMarked',
};

export const ACT_PRODUCT_TYPES = {
    [ActProductType.Cpc]: 'admin.actsReport.productType.cpc',
    [ActProductType.Auction]: 'admin.actsReport.productType.auction',
    [ActProductType.Segments]: 'admin.actsReport.productType.segments',
};

export enum ActEditingField {
    DocumentNumber = 'documentNumber',
    CorrectedAmount = 'correctedAmount',
    PeriodEnd = 'period',
    PeriodStart = 'periodStart',
    Status = 'status',
    SendStatus = 'actSendStatus',
    ActDate = 'actDate',
}

export const INVOICE_PAYMENT_TYPE_BONUS = 'BONUS';

export const enum ChangeHistoryTableHeaders {
    User = 'user',
    RealUser = 'realUser',
    UserIpAddress = 'userIpAddress',
    Date = 'date',
    Field = 'field',
    OldValue = 'oldValue',
    NewValue = 'newValue',
    ChangeSource = 'changeSource',
}

export enum ChangeHistoryType {
    Campaign = 'CAMPAIGN',
    Banner = 'BANNER',
    Act = 'ACT',
}

export const CHANGE_HISTORY_TABLE_HEADERS_WIDTHS: Record<ChangeHistoryTableHeaders, number> = {
    [ChangeHistoryTableHeaders.User]: 184,
    [ChangeHistoryTableHeaders.RealUser]: 0,
    [ChangeHistoryTableHeaders.UserIpAddress]: 0,
    [ChangeHistoryTableHeaders.Date]: 110,
    [ChangeHistoryTableHeaders.Field]: 120,
    [ChangeHistoryTableHeaders.OldValue]: 130,
    [ChangeHistoryTableHeaders.NewValue]: 160,
    [ChangeHistoryTableHeaders.ChangeSource]: 120,
};

export enum ChangeHistoryCampaignFieldName {
    Creation = 'CREATION',
    Status = 'STATUS',
    Sources = 'SOURCES',
    Budget = 'BUDGET',
    DailyBudget = 'DAILY_BUDGET',
    BudgetShares = 'BUDGET_SHARES',
    Regions = 'REGIONS',
    Sex = 'SEX',
    ProfArea = 'PROF_AREA',
    Title = 'TITLE',
    Age = 'AGE',
    AgeIncludeAnonymous = 'AGE_INCLUDE_ANONYMOUS',
    Language = 'LANGUAGE',
    DeviceType = 'DEVICE_TYPE',
    Salary = 'SALARY',
    SalaryIncludePredicted = 'SALARY_INCLUDE_PREDICTED',
    AutoSource = 'AUTO_SOURCE',
}

export enum ChangeHistoryBannerFieldName {
    Creation = 'CREATION',
    Status = 'STATUS',
    Text = 'TEXT',
    Url = 'URL',
    Title = 'TITLE',
    Image = 'IMAGE',
}

export enum OverflowTypeSearch {
    Id = 'ADMIN_OVERFLOW_TYPE_BY_ID',
    Dates = 'ADMIN_OVERFLOW_TYPE_BY_DATES',
}

export const ADMIN_OVERFLOW_CAMPAIGN_ID = 'campaignId';
export const ADMIN_OVERFLOW_VALUE = 'overflow';
export const ADMIN_OVERFLOW_SOURCE = 'apiSource';

export const BILLING_FUNNEL_TOTAL = 'TOTAL';

const enum BillingFunnelHeaders {
    AccountId = 'accountId',
    StatisticAmount = 'statisticAmount',
    FixedStatisticAmount = 'fixedStatisticAmount',
    FixedStatisticRealAmount = 'fixedStatisticRealAmount',
    FixedStatisticBonusAmount = 'fixedStatisticBonusAmount',
    ActAmount = 'actAmount',
}

export const BILLING_FUNNEL_HEADERS = [
    BillingFunnelHeaders.AccountId,
    BillingFunnelHeaders.StatisticAmount,
    BillingFunnelHeaders.FixedStatisticAmount,
    BillingFunnelHeaders.FixedStatisticRealAmount,
    BillingFunnelHeaders.FixedStatisticBonusAmount,
    BillingFunnelHeaders.ActAmount,
];

const enum EfficiencyHeaders {
    Source = 'source',
    Impressions = 'impressions',
    Clicks = 'clicks',
    CTR = 'ctr',
    VacancyViews = 'vacancyViews',
    VTCR = 'vtcr',
    NewRegistrations = 'newRegistrations',
    AnyResponseFromUsers = 'anyResponseFromUsers',
    ResponseOnClickmeVacancy = 'responseOnClickmeVacancy',
    CR = 'cr',
}

export const EFFICIENCY_HEADERS = [
    EfficiencyHeaders.Source,
    EfficiencyHeaders.Impressions,
    EfficiencyHeaders.Clicks,
    EfficiencyHeaders.CTR,
    EfficiencyHeaders.VacancyViews,
    EfficiencyHeaders.VTCR,
    EfficiencyHeaders.NewRegistrations,
    EfficiencyHeaders.AnyResponseFromUsers,
    EfficiencyHeaders.ResponseOnClickmeVacancy,
    EfficiencyHeaders.CR,
];

export const enum AccountStatisticsHeaders {
    Source = 'source',
    Impressions = 'impressions',
    Clicks = 'clicks',
    Amount = 'amount',
}

export const ACCOUNT_STATISTICS_HEADERS = [
    AccountStatisticsHeaders.Source,
    AccountStatisticsHeaders.Impressions,
    AccountStatisticsHeaders.Clicks,
    AccountStatisticsHeaders.Amount,
];

export const enum RemainderBudgetsHeaders {
    ApiSource = 'apiSource',
    TotalAmount = 'totalAmount',
    Remainder = 'remainder',
}

export const REMAINDER_BUDGETS_HEADERS = [
    RemainderBudgetsHeaders.ApiSource,
    RemainderBudgetsHeaders.TotalAmount,
    RemainderBudgetsHeaders.Remainder,
];

export const enum SourceAccountsHeaders {
    ApiSource = 'apiSource',
    ClientId = 'clientId',
    DisplayName = 'displayName',
    Link = 'link',
    CampaignLink = 'campaignLink',
}

export const SOURCE_ACCOUNTS_HEADERS = [
    SourceAccountsHeaders.ApiSource,
    SourceAccountsHeaders.ClientId,
    SourceAccountsHeaders.DisplayName,
    SourceAccountsHeaders.Link,
    SourceAccountsHeaders.CampaignLink,
];

export const enum AdminInvoiceCreateError {
    EmptyAmount = 'EMPTY_AMOUNT',
    EmptyAccountId = 'EMPTY_ACCOUNT_ID',
    UnnecessaryAccountId = 'UNNECESSARY_ACCOUNT_ID',
}

export enum YandexDirectReportType {
    ORD = 'ORD',
    REFUND = 'REFUND',
}

export enum RefundReason {
    User = 'USER',
    Writeoff = 'WRITE_OFF',
}
